import styled from '@emotion/styled';
import { Snackbar } from '@mui/material';

const CustomSnackbar = styled(Snackbar)`
    border-radius: 20px;
    padding: ${({ theme }) => `${theme.spacing(3)}`};
    max-width: fit-content;
    flex-wrap: nowrap;

    & .MuiSnackbarContent-message {
        font-family: ${({ theme }) => theme.fonts.primary};
    }

    & .MuiSnackbarContent-root {
        padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
    }
`;
export { CustomSnackbar };
